import { DraftState } from '@/types';
import { withoutHistory } from '@/components/draft/draftState/history/withoutHistory';

export const setWarningAction = (key: string, warning?: string) =>
  withoutHistory((draft: DraftState) => {
    if (warning) {
      draft.warnings[key] = warning;
    } else if (draft.warnings[key]) {
      delete draft.warnings[key];
    }
  });
